import React from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { useTranslation } from '../hooks/useTranslation';
import CookieSettingsModal from './CookieSettingsModal';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const { 
    showConsentBanner, 
    showSettingsModal,
    acceptAllCookies, 
    acceptEssentialOnly,
    openSettings,
    closeSettings
  } = useCookieConsent();

  // Don't render if banner shouldn't be shown
  if (!showConsentBanner) {
    return null;
  }

  const handleCustomizeClick = () => {
    openSettings();
  };

  const handleCloseModal = () => {
    closeSettings();
  };

  return (
    <>
      {/* Cookie Banner */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900/95 backdrop-blur-sm border-t border-gray-700 p-4 shadow-lg">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {/* Content */}
          <div className="flex-1 text-sm text-gray-300">
            <p className="mb-2">
              <span className="font-semibold text-white">
                {t('gdpr.cookie_banner.title')}
              </span>
            </p>
            <p className="text-gray-400 leading-relaxed">
              {t('gdpr.cookie_banner.description')}
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 min-w-fit">
            {/* Customize Settings - Equal prominence with Accept All */}
            <button
              onClick={handleCustomizeClick}
              className="px-6 py-2.5 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200 border border-gray-600 hover:border-gray-500"
            >
              {t('gdpr.cookie_banner.customize')}
            </button>
            
            {/* Accept All - Equal prominence with Customize */}
            <button
              onClick={acceptAllCookies}
              className="px-6 py-2.5 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors duration-200"
            >
              {t('gdpr.cookie_banner.accept_all')}
            </button>
          </div>
        </div>

        {/* Essential Only Link - Less prominent */}
        <div className="max-w-7xl mx-auto mt-3 pt-3 border-t border-gray-800">
          <button
            onClick={acceptEssentialOnly}
            className="text-sm text-gray-400 hover:text-gray-300 underline transition-colors duration-200"
          >
            {t('gdpr.cookie_banner.essential_only')}
          </button>
        </div>
      </div>

      {/* Cookie Settings Modal */}
      {showSettingsModal && (
        <CookieSettingsModal 
          isOpen={showSettingsModal}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default CookieBanner;